import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RevenueVsBudgetRow, IConsultingRevenueVsBudgetQuery } from "models/consulting-revenue-budget"
import FiscalCalendar from "utils/fiscal-calendar"

const getDefaultQuery = (): IConsultingRevenueVsBudgetQuery => {
    const lastMonth = FiscalCalendar.getLastMonthPeriod()
    return { fromPeriod: lastMonth, toPeriod: lastMonth }
}

export interface ConsultingRevenueVsBudgetSliceState {
    query: IConsultingRevenueVsBudgetQuery
    byDivision: RevenueVsBudgetRow[]
    byBranch: RevenueVsBudgetRow[]
    byDepartment: RevenueVsBudgetRow[]
}

export const initialState: ConsultingRevenueVsBudgetSliceState = {
    query: getDefaultQuery(),
    byDivision: [],
    byBranch: [],
    byDepartment: [],
}

const consultingRevenueVsBudgetSlice = createSlice({
    name: 'consultingRevenueVsBudget',
    initialState,
    reducers: {
        setQuery(state, { payload }: PayloadAction<IConsultingRevenueVsBudgetQuery>) {
            state.query = payload
        },
        setData(state, { payload }: PayloadAction<{ byDivision: RevenueVsBudgetRow[], byBranch: RevenueVsBudgetRow[], byDepartment: RevenueVsBudgetRow[] }>) {
            state.byDivision = payload.byDivision
            state.byBranch = payload.byBranch
            state.byDepartment = payload.byDepartment
        },
    }
})

export const { setData, setQuery } = consultingRevenueVsBudgetSlice.actions
export default consultingRevenueVsBudgetSlice.reducer
